export default __webpack_public_path__ + "static/media/arrTop.8c3f03a9.svg";